import { ORDER_TYPE, OPTION_TYPE, PiCKUP_TIME, ORDER_STATUS, PAYMENT_TYPE } from "./enums";
import i18n from "../i18n";
import _ from "lodash";
import {
  isChrome,
  isFirefox,
  isSafari,
  isOpera,
  isIE,
  isEdge,
  isYandex,
  isChromium,
  isMobileSafari,
} from "mobile-device-detect";

import functions from "@/utilities/functions";
import Vue from "vue";

export function getOrderTotal(cart, order_type) {
  if (!cart.order || cart.order.length <= 0) return 0;
  let total = 0;
  for (let i = 0; i < cart.order.length; i++) {
    total += getMenuItemTotal(cart.order[i], order_type);
  }
  return total;
}

export function getMenuItemPrice(menuItem, orderType) {
  let price = menuItem.price;
  if (!orderType) return price;

  if (menuItem.is_special) return menuItem.special_price;

  switch (orderType) {
    case ORDER_TYPE.Delivery.id: {
      price =
        menuItem.delivery_price && menuItem.delivery_price != "0.00"
          ? menuItem.delivery_price
          : menuItem.price && menuItem.price != 0
            ? menuItem.price
            : menuItem.originalMenuItem.delivery_price &&
              menuItem.originalMenuItem.delivery_price != 0
              ? menuItem.originalMenuItem.delivery_price
              : menuItem.originalMenuItem.price;
      break;
    }
    case ORDER_TYPE.Collection.id: {
      price =
        menuItem.collection_price && menuItem.collection_price != "0.00"
          ? menuItem.collection_price
          : menuItem.price && menuItem.price != 0
            ? menuItem.price
            : menuItem.originalMenuItem.collection_price &&
              menuItem.originalMenuItem.collection_price != 0
              ? menuItem.originalMenuItem.collection_price
              : menuItem.originalMenuItem.price;
      break;
    }
    case ORDER_TYPE.Table.id: {
      price =
        menuItem.sitin_price && menuItem.sitin_price != "0.00"
          ? menuItem.sitin_price
          : menuItem.price && menuItem.price != 0
            ? menuItem.price
            : menuItem.originalMenuItem.sitin_price &&
              menuItem.originalMenuItem.sitin_price != 0
              ? menuItem.originalMenuItem.sitin_price
              : menuItem.originalMenuItem.price;
      break;
    }
  }
  return parseFloat(price);
}

export function getMenuItemTotal(item, order_type) {
  if (!item) return 0;

  let itemTotal = getMenuItemPrice(item, order_type);

  if (item.hasOptions && item.options) {
    item.options.forEach((option) => {
      itemTotal += getOptionTotal(option);
    });
  }

  if (item.is_meal_deal && item.sections) {
    item.sections.forEach((section) => {
      itemTotal += getSectionTotal(section, order_type);
    });
  }

  return itemTotal * item.quantity;
}

// bundle price is always 0 only if the subProduct has options
export function getSectionTotal(section, order_type) {
  let itemTotal = 0;
  if (section?.originalMenuItem?.product_type == 4) {
    // section
    // calculate the subTotal
    section.selected_items.forEach((item) => {
      let itemFound = section.subProducts.find((x) => x.id == item.id);

      itemTotal +=
        parseFloat(getMenuItemTotal(itemFound, order_type)) *
        item.quantity;
    });
    return itemTotal;
  }
}

export function getOptionTotal(option) {

  let optionTotal = 0;
  if (!option.selected_items) return 0;

  let selected_items = getAllSelectItems(option)

  selected_items.forEach((val) => {
    if (val) {
      optionTotal += parseFloat(val.price) * val.quantity;
    }
  });
  return optionTotal;
}

export function getAllSelectItems(option) {

  if (!option.selected_items) return [];

  let selected_items = option.selected_items;
  option.values.forEach(value => {
    if (value.options?.length) {
      value.options.forEach(opt => {
        if (opt?.selected_items?.length) {
          selected_items = [...selected_items, ...opt.selected_items]
        }
      })
    }
  })

  return selected_items
}

export function checkRequiredOptions(options) {
  return new Promise((resolve, reject) => {
    options.forEach((option) => {

      if (
        option.is_required &&
        (!option.selected_items.length ||
          !option.selected_items.filter((el) => el !== null).length)
      ) {

        reject(
          i18n.t(
            option.type == "RADIO" || option.type == "SELECT"
              ? "message.select_one_option"
              : "message.select_least_one_option",
            { option_name: option.name }
          )
        );
      }
    });

    resolve(false);
  });
}

export function checkIfAnyOptionIsSelected(options) {
  return new Promise((resolve) => {
    if (!options) resolve(true);

    options.forEach((option) => {
      if (isEmpty(option.selected)) resolve(true);
    });
    resolve(false);
  });
}

export function isEmpty(value) {
  return (value && value != "") || (Array.isArray(value) && value.length);
}

export function canMakeOrder(selectedLocation, isMounted = true) {
  let status = {
    open: false,
    can_make_order: false,
    accepts_future_orders: false,
    can_accept_delivery: false,
    can_accept_collection: false,
    can_accept_tableOrdering: false,
    openingHours: selectedLocation ? selectedLocation.openingHours : [],
  };

  if (
    _.isEmpty(selectedLocation) ||
    !isMounted ||
    selectedLocation.openingHours.suspended
  )
    return status;

  status.open =
    selectedLocation.openingHours.delivery ||
    selectedLocation.openingHours.collection ||
    selectedLocation.openingHours.sitIn;
  status.accepts_future_orders =
    selectedLocation.orderSetting.accepts_future_orders;
  status.openingHours = selectedLocation.openingHours;

  //--- a user can order only if the location is open or accept_future_orders and today is included in one of (delivery_time or pick_time)
  //let delivery_time = selectedLocation.delivery_time;

  const canAcceptDelivery =
    status.openingHours.delivery ||
    functions.isDeliveryTypeAvailble(
      selectedLocation.delivery_time,
      selectedLocation.orderSetting
    );

  const canAcceptCollection =
    //status.openingHours.collection ||
    functions.isCollectionTypeAvailble(
      selectedLocation.pickup_time,
      selectedLocation.orderSetting
    );

  const canAcceptTableOrdering =
    status.openingHours.sitIn &&
    functions.isTableTypeAvailble(selectedLocation.tableOrdering_time);

  status.can_accept_delivery =
    selectedLocation.orderSetting.offer_delivery && canAcceptDelivery;
  status.can_accept_collection =
    selectedLocation.orderSetting.offer_collection && canAcceptCollection;
  status.can_accept_tableOrdering =
    selectedLocation.orderSetting.offer_tableordering && canAcceptTableOrdering;

  status.can_make_order =
    canAcceptDelivery || canAcceptCollection || canAcceptTableOrdering;

  return status;
}

export function controlAvailibilityBeforeCheckout(locationStatus, cart) {
  if (cart === null) return true;

  if (locationStatus.openingHours.suspended) return true;

  if (!locationStatus.can_make_order) return true;

  if (cart.orderType == ORDER_TYPE.Collection.id) {
    return !locationStatus.can_accept_collection;
  }

  if (cart.orderType == ORDER_TYPE.Delivery.id) {
    return !locationStatus.can_accept_delivery;
  }
  if (cart.orderType == ORDER_TYPE.Table.id) {
    return !locationStatus.can_accept_tableOrdering;
  }

  return true;
}

export function checkOrderItemsAvailibilityForToday(order, time, menu) {
  return new Promise((resolve) => {

    const dayNumber = time.format("d");
    const selectedtime = time.format("HH:mm:ss");
    let itemsNotAvailableFor = {
      today: [],
      now: [],
    };
    order.forEach((item) => {
      let isAvailable = true;
      if (item.mealDays.length || item.mealTimes.length) {
        //--- refresh the cart order item from the menu
        let itemFound = refreshCartOrderItemsData(item, menu);
        if (!itemFound) {
          itemsNotAvailableFor.today.push(item);
        } else {
          //--- check if mealDays is configured => check if the items is available for today
          isAvailable = orderItemsAvailibilityforToday(
            itemFound,
            dayNumber
          );
          if (!isAvailable) {
            itemsNotAvailableFor.today.push(itemFound);
          }

          if (
            isAvailable &&
            !orderItemAvailibilityforNow(itemFound, selectedtime)
          ) {
            itemsNotAvailableFor.now.push(itemFound);
          }
        }
      }
    });
    resolve(itemsNotAvailableFor);
  });
}

export function checkRequiredAllRequiredItems(orderItems) {
  return new Promise((resolve, reject) => {

    const result = checkRequiredMenuItemSections(orderItems)

    Vue.nextTick(() => {
      if (result.length) reject(`<p class="font-weight-bold">Pleace Select all the following required Items</p><ul class="text-left">${result}</ul>`);
      resolve(true);
    });
  });
}
export function checkRequiredMenuItemSections(orderItems) {
  let result = "";
  orderItems.forEach((element) => {
    if (element.options?.length) {
      result += checkRequiredItemsRecursively(element.options, true)
    }
    if (element.sections?.length) {
      result += checkRequiredItemsRecursively(element.sections, false)
    }
  });

  return result;
}

export function checkRequiredItemsRecursively(Items, isOption = true) {
  const onlyRequiredItems = Items.filter(op => op.is_required);
  let result = ""
  onlyRequiredItems.forEach((item) => {

    if (!item.selected_items.length) {
      result += `<li>${item.name}</li>`
    }

    if (isOption) {
      const valuesWithOptions = item.values.filter(v => item.selected_items.map(m => m.id).includes(v.id) && v.options?.length);
      for (const value of valuesWithOptions) {
        result += checkRequiredItemsRecursively(value.options, true, value.name)
      }
    } else {
      const sectionSubProducts = item.subProducts.filter(v => item.selected_items.map(m => m.id).includes(v.id) && v.subProducts?.length);
      for (const section of sectionSubProducts) {
        result += checkRequiredMenuItemSections(section.subProducts, false, section.name)
      }
    }
  });
  return result;
}

//-- get delivery fee based on the delivery areas locations
export function getDeliveryFee(delivery_condition, total_cart) {
  let result = getAllAreasConditions(delivery_condition, "total");

  if (result.length === 1) return result[0].charge;

  result = result.reverse();

  // get the all charges that have the same total and get the min of the charges
  let result_charges = result.filter((item) => {
    return item.total <= total_cart;
  });

  const charges = result_charges.map((a) => a.charge);

  if (charges.length) return Math.min(...charges);
  else return getDefaultDeliveryFee(delivery_condition);
}
// get minimum cat total to allow a delivery
export function getMinimumDeliveryPrice(delivery_condition) {
  let result = getAllAreasConditions(delivery_condition, "total");
  return result[0].total;
}

// get minimum cat total to allow a delivery
export function getDefaultDeliveryFee(delivery_condition) {
  let result = getAllAreasConditions(delivery_condition, "total");
  return result[0].charge;
}

export function refreshCartOrderItemsData(orderItem, menu) {
  for (let j = 0; j < menu.length; j++) {
    let menuCategory = menu[j];
    let foundOrderItem = menuCategory.menu_items.find(
      (x) => x.id == orderItem.id
    );
    if (foundOrderItem) {
      return updateOrderItem(orderItem, foundOrderItem);
    }
    for (var k = 0; k < menuCategory.children.length; ++k) {
      var menuCategoryChildren = menuCategory.children[k].menu_items;
      foundOrderItem = menuCategoryChildren.find((x) => x.id == orderItem.id);

      if (foundOrderItem) {
        return updateOrderItem(orderItem, foundOrderItem);
      }
    }
  }
  return false; // item not found
}

export function orderItemsAvailibilityforToday(item, dayNumber) {
  if (item.mealDays.length) {
    let itemFound = item.mealDays.find((mealDay) =>
      mealDay.days.find(day => day == dayNumber)
    );
    return !!itemFound;
  }
  return true;
}

export function getAllAreasConditions(delivery_condition, sortedBy) {
  if (!delivery_condition) return [];
  let all_values = [];
  delivery_condition.forEach((condition) => {
    all_values = [
      ...all_values,
      ...condition.items.map((item) => ({
        charge: parseFloat(item.charge),
        total: parseFloat(item.total),
      })),
    ];
  });
  return all_values.sort(functions.compareValues(sortedBy));
}

export function updateOrderItem(orderItem, foundOrderItem) {
  orderItem.mealDays = foundOrderItem.mealDays;
  orderItem.mealTimes = foundOrderItem.mealTimes;
  return orderItem;
}

export function orderItemAvailibilityforNow(item, nowTime) {
  if (item.mealTimes.length) {
    let itemFound = item.mealTimes.find(
      (mealTime) => mealTime.start_at <= nowTime && mealTime.end_at >= nowTime
    );
    return !!itemFound;
  }
  return true;
}

export function showErrorMessageAlert(
  message,
  icon = null,
  color = "red",
  okText = "OK"
) {
  let full_message = "";
  full_message += icon
    ? "<p><i class='" + icon + "' style='color:" + color + "' ></i></p>"
    : "";

  full_message += "<p>" + message + "</p>";

  let options = {
    html: true,
    animation: "fade",
    type: "basic",
    backdropClose: false,
    customClass: "confirm wtf-confirm",
    okText: okText,
  };
  return new Promise((resolve) => {
    Vue.prototype.$dialog.alert(full_message, options).then(() => {
      resolve(true);
    });
  });
}

export function getMessageFromAPIError(data, _default = null) {
  let msg = _default ? _default : i18n.t("generic_error.error_occured");

  if (data.error) {
    if (data.error.details && typeof data.error.details === "object") {
      let keys = Object.keys(data.error.details);
      keys.forEach((key) => {
        msg = Array.isArray(data.error.details[key])
          ? data.error.details[key][0]
          : data.error.details[key];
      });
    } else {
      msg = data.error.message
        ? data.error.message
        : data.error
          ? data.error
          : msg;
    }
  } else if (data.errors) {
    let keys = Object.keys(data.errors);
    keys.forEach((key) => {
      msg = data.errors[key][0];
    });
  }
  return msg;
}

export function checkIfItemAvailbleByOrderType(orderType, item) {

  switch (orderType) {
    case ORDER_TYPE.Delivery.id:
      return item.allow_delivery;
    case ORDER_TYPE.Collection.id:
      return item.allow_collection;
    case ORDER_TYPE.Table.id:
      return item.allow_sitin;
  }
}

export function filterLocationsByOrderType(orderType, locations) {
  switch (orderType) {
    case ORDER_TYPE.Delivery.id:
      return locations.filter(
        (x) => canMakeOrder(x).can_accept_delivery
        //x.orderSetting && x.orderSetting.offer_delivery
      );
    case ORDER_TYPE.Collection.id:
      return locations.filter(
        (x) => canMakeOrder(x).can_accept_collection
      );
    case ORDER_TYPE.Table.id:
      return locations.filter(
        (x) => canMakeOrder(x).can_accept_tableOrdering
      );
  }
}

export function getServiceChargeByType(
  service_charges,
  order_type,
  defaultServiceCharge
) {
  const charge = service_charges[order_type];
  return charge ? charge : defaultServiceCharge;
}
export function getMenuItemDieatriesIcons(menuIetimOrginal) {
  if (
    !menuIetimOrginal ||
    !menuIetimOrginal.dietaries ||
    !menuIetimOrginal.dietaries.length
  )
    return [];

  return menuIetimOrginal.dietaries.map((element) => {
    return { icon: `dietary-${element.slug}`, name: element.name }
  })
}

export function isMaxQuantityReached(quantity, maxQuantity, multiMax) {

  return multiMax ? multiMax == quantity : maxQuantity && (quantity >= maxQuantity || quantity >= 999);
}

export function isGlobalQuantityReached(items, maxQuantity) {

  const total = items.length
  return maxQuantity && (total >= maxQuantity || total >= 999);
}

export function formatSelectedItems(options, className = "") {
  let result = "";
  options.forEach((option) => {
    if (option.selected_items.length) {
      option.selected_items.forEach((selectedItem) => {
        result += `<p class="mb-0 ${className}">++ ${selectedItem.name} (x${selectedItem.quantity})</p>`;
      });
    }
  });
  return result;
}

export function clone(mainArray) {
  return JSON.parse(JSON.stringify(mainArray));
}

export function getCookieTimeExpiration() {
  return 30 * 60 * 1000;
}

export function generateFormatedDateTime(
  value,
  type = "date",
  fromat = "dddd Do MMM  YYYY",
  lang = null
) {
  if (type == "date") {
    if (lang != null) {
      const resource = lang == "en" ? "en-gb" : lang;
      return Vue.prototype
        .$moment(value)
        .locale(resource)
        .format(fromat);
    } else {
      return Vue.prototype.$moment(value).format(fromat);
    }
  }
  let time = Vue.prototype.$moment(value, "HH:mm");
  return time.format(fromat);
}

export function IsWebView() {
  return (
    !isChrome &&
    !isFirefox &&
    !isSafari &&
    !isOpera &&
    !isIE &&
    !isEdge &&
    !isYandex &&
    !isChromium &&
    !isMobileSafari
  );
}

export function getOrderTypeText(type) {
  switch (type) {
    case ORDER_TYPE.Delivery.id:
      return i18n.t("text.delivery");
    case ORDER_TYPE.Collection.id:
      return i18n.t("text.collection");
    case ORDER_TYPE.Table.id:
      return i18n.t("text.table");
  }
}

export function checkPriceDifference(fullOrderItem, cartOrderItem, order_type) {
  let menuItemPrice = parseFloat(getMenuItemPrice(fullOrderItem.menuItem, order_type));
  let orderItemPrice = parseFloat(cartOrderItem.price)

  if (menuItemPrice != orderItemPrice) {

    return {
      name: fullOrderItem.name,
      menuItemPrice,
      orderItemPrice,
      increased: menuItemPrice > orderItemPrice
    }
  }
}

export function getReOrderItemTotal(fullOrderItem, cartOrderItem, order_type) {

  let diffPrices = []

  let diffFounded = checkPriceDifference(fullOrderItem, cartOrderItem, order_type);

  if (diffFounded) {

    diffPrices.push(diffFounded)
  }
  if (cartOrderItem.options?.length) {
    let optionDiffFound = checkOrderItemOptionsPriceDifference(fullOrderItem.menuItem.options, cartOrderItem.options)
    if (optionDiffFound) {
      diffPrices = [...diffPrices, ...optionDiffFound]
    }
  }

  if (cartOrderItem.sections?.length) {

    cartOrderItem.sections.forEach(section => {

      let orderItemSectionFound = fullOrderItem.sections.find(s => s.id == section.id)


      section.subProducts.forEach(subProduct => {

        let fullOrderItemFound = orderItemSectionFound.sections.find(p => p.id == subProduct.id)

        if (fullOrderItemFound) {
          diffPrices = [...diffPrices, ...getReOrderItemTotal(fullOrderItemFound, subProduct, order_type)]

        }
      })

    })
  }
  return diffPrices;

}

export function checkOrderItemOptionsPriceDifference(fullOrderItemOptions, cartOrderItemOptions) {
  let diffPrices = [];
  cartOrderItemOptions.forEach(option => {
    if (option.is_deleted) {
      return;
    }

    let fullOrderItemOptionFound = fullOrderItemOptions.find(o => o.id == option.menu_option_id)

    if (!fullOrderItemOptionFound) { return; }
    option.values.forEach(value => {
      if (value.is_deleted) {
        return;
      }

      let menuItemValueFound = fullOrderItemOptionFound.values?.find(v => v.id == value.menu_option_value_id)

      if (menuItemValueFound) {

        let menuItemValuePrice = parseFloat(menuItemValueFound.price);
        let orderItemValuePrice = parseFloat(value.price);

        if (orderItemValuePrice != menuItemValuePrice) {

          diffPrices.push({
            name: menuItemValueFound.name,
            menuItemPrice: menuItemValuePrice,
            orderItemPrice: orderItemValuePrice,
            increased: menuItemValuePrice > orderItemValuePrice
          })
        }
      }

      if (value.options?.length && menuItemValueFound.options?.length) {
        diffPrices = [...diffPrices, ...checkOrderItemOptionsPriceDifference(menuItemValueFound.options, value.options)]
      }
    })
  })

  return diffPrices;
}

export function getStripeKey() {
  return process.env.VUE_APP_STRIPE_KEY;
}

export function geMessageByStripeErrorCode(error_code) {
  if (error_code.error)
    return error_code.error.message
      ? error_code.error.message
      : error_code.error
        ? error_code.error
        : i18n.t("message.payment_failed");
  else
    return error_code.message
      ? error_code.message
      : i18n.t("message.payment_failed");
}

export function getMessageByStripePaymentIntent(status) {
  let msg = i18n.t("generic_error.error_payment_failed");
  switch (status) {
    case "requires_payment_method":
    case "requires_source":
    case "requires_confirmation":
    case "processing":
    case "canceled": {
      msg = i18n.t("generic_error.stripe_payment_failed");
      break;
    }
  }
  return msg;
}

export function generateFromatedAddress(objAddress, inline = false) {
  if (!objAddress) return "";
  let strAddress = `${objAddress.street_number ? objAddress.street_number : ""
    } ${objAddress.address_line_1 ? objAddress.address_line_1 : ""} `;

  if (objAddress.address_line_2) strAddress += objAddress.address_line_2 + " ";

  if (inline) strAddress += "<br>";
  strAddress += `${objAddress.city ? objAddress.city : ""} `;
  if (inline) strAddress += "<br>";
  strAddress += `${objAddress.region ? objAddress.region : ""} `;

  if (inline) strAddress += "<br>";
  strAddress += `${objAddress.postcode ? objAddress.postcode : ""}`;

  return strAddress.trim();
}

export function generateOrderDateTime(pickUp) {
  let now = Vue.prototype.$moment(new Date());

  if (pickUp.type == PiCKUP_TIME.ASAP) {
    return Vue.prototype.$moment(now, "YYYY-MM-DD HH:mm:ss");
  }

  return Vue.prototype.$moment(
    Vue.prototype
      .$moment(
        Vue.prototype.$moment(
          generateFormatedDateTime(pickUp.date, "date", "YYYY-MM-DD") +
          " " +
          generateFormatedDateTime(pickUp.time, "time", "HH:mm:ss")
        )
      )
      .format("YYYY-MM-DD HH:mm:ss"),
    "YYYY-MM-DD HH:mm:ss"
  );
}

export function validLastOrderDateTime(location, orderType, pickUp) {
  let orderTime = generateOrderDateTime(pickUp);

  let dateTimes = [];
  switch (orderType) {
    case ORDER_TYPE.Delivery.id:
      dateTimes = location.delivery_time;
      break;
    case ORDER_TYPE.Collection.id:
      dateTimes = location.pickup_time;
      break;
    case ORDER_TYPE.Table.id:
      dateTimes = location.tableOrdering_time;
      break;
  }

  let array_dates = Object.keys(dateTimes);
  if (array_dates.length <= 0) return false;
  // no time found => can't continue with the ordering

  for (let k = 0; k < array_dates.length; k++) {
    let key = array_dates[k];

    let times = dateTimes[key];
    for (let i = 0; i < times.length; i++) {
      let closes_at = Vue.prototype.$moment(
        Vue.prototype
          .$moment(`${key} ${times[i].closes_at}`)
          .format("YYYY-MM-DD HH:mm:ss"),
        "YYYY-MM-DD HH:mm:ss"
      );

      let opens_at = Vue.prototype.$moment(
        Vue.prototype
          .$moment(`${key} ${times[i].opens_at}`)
          .format("YYYY-MM-DD HH:mm:ss"),
        "YYYY-MM-DD HH:mm:ss"
      );

      if (
        orderTime.isSameOrAfter(opens_at) &&
        orderTime.isSameOrBefore(closes_at)
      )
        return true;
    }
  }
  Vue.nextTick(() => {
    return false;
  });
}
export function pad2(number) {
  return (number < 10 ? "0" : "") + number;
}

export function showMessageConfirmation(
  message,
  icon = null,
  color = "red",
  okText = i18n.t("button.continue"),
  cancelText = i18n.t("button.cancel")
) {
  return new Promise((resolve) => {
    let full_message = "";
    full_message += icon
      ? "<p><i class='" + icon + "' style='color:" + color + "' ></i></p>"
      : "";
    full_message += "<p>" + message + "</p>";

    let options = {
      html: true,
      animation: "fade",
      type: "basic",
      backdropClose: false,
      customClass: "confirm",
      okText: okText,
      cancelText: cancelText,
    };
    Vue.prototype.$dialog
      .confirm(full_message, options)
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function evaluateValue(value) {
  return value ? true : false;
}

export function roundTimeQuarterHour(time, minutesToRound = 15) {
  let [hours, minutes] = time.split(":");
  hours = parseInt(hours);
  minutes = parseInt(minutes);

  // Convert hours and minutes to time in minutes
  time = hours * 60 + minutes;

  let rounded = Math.ceil(time / minutesToRound) * minutesToRound;

  let rHr = "" + Math.floor(rounded / 60);
  let rMin = "" + (rounded % 60);
  return rHr.padStart(2, "0") + ":" + rMin.padStart(2, "0");
}

export function getQuarterOrderTimesFromPeriod(date, periodStart, periodEnd) {
  let result = [];
  let dtPeriodeEnd = Vue.prototype.$moment(
    date + " " + periodEnd,
    "YYYY-MM-DD HH:mm"
  );
  let dtPeriodeStart = Vue.prototype.$moment(
    date + " " + periodStart,
    "YYYY-MM-DD HH:mm"
  );

  while (dtPeriodeStart.isSameOrBefore(dtPeriodeEnd)) {
    result.push({
      name: dtPeriodeStart.format("HH:mm"),
    });
    dtPeriodeStart = addQuarterToTime(dtPeriodeStart);
  }
  return result;
}

export function addQuarterToTime(value) {
  return value.add(15, "minutes");
}

export function getCardBrandIcon(stripe_object) {
  let brand_img = "/img/";
  if (!stripe_object) {
    brand_img += "unknown.svg";
    return brand_img;
  }
  switch (stripe_object.brand) {
    case "Visa":
      brand_img += "Visa.svg";
      break;
    case "MasterCard":
      brand_img += "Mastercard.svg";
      break;
    case "American Express":
      brand_img += "Amex.svg";
      break;
    case "Diners Club":
      brand_img += "Diners-Club.svg";
      break;
    case "Discover":
      brand_img += "Discover-card.svg";
      break;
    default:
      brand_img += "unknown.svg";
      break;
  }
  return brand_img;
}

export function getCardNumberWithStars(last4) {
  return "**** **** **** " + last4;
}

export function getStripeApiVersion() {
  return process.env.VUE_APP_STRIPE_API_VERSION
    ? process.env.VUE_APP_STRIPE_API_VERSION
    : "2015-04-07";
}

export function getValueName(values, idValue) {
  let valueFound = values.find((x) => x.id == idValue);
  if (valueFound) return valueFound.name;
  return i18n.t("text.VALUE_NOT_FOUND");
}
export function checkforAutoCoupon(selectedLocation) {
  if (selectedLocation.coupons && selectedLocation.coupons.length) {
    return selectedLocation.coupons.find((c) => c.auto_applied);
  }
  return null;
}
//--- start filter the categories
export function $_find(items, _searchTerm, _type, _orderType, predicate) {
  let matches = [];
  if (!items) return null;
  for (let obj of items) {
    var item = Object.assign({}, obj);
    if (_type == "menu" && predicate(item, _searchTerm)) {
      //--- if the category name contain to the _searchTerm => return all the corresponding items by the selected type
      //matches.push(item);
      item.menu_items = filterMenuItemByType(item, _orderType);
      if (item.children.length) {
        let subMatches = $_find(
          item.children,
          _searchTerm,
          _type,
          _orderType,
          predicate
        );
        if (subMatches.length) {
          matches.push({
            ...item,
            children: subMatches,
          });
        } else {
          item.children = [];
          if (item.menu_items && item.menu_items.length) {
            matches.push(item);
          }
        }
      } else if (item.menu_items && item.menu_items.length) {
        matches.push(item);
      }
    } else {
      item.menu_items = filterMenuItem(
        item,
        _searchTerm,
        _type,
        _orderType
      );
      if (item.children.length) {
        let subMatches = $_find(
          item.children,
          _searchTerm,
          _type,
          _orderType,
          predicate
        );

        if (subMatches.length) {
          matches.push({
            ...item,
            children: subMatches,
          });
        } else {
          item.children = [];
          if (item.menu_items && item.menu_items.length) {
            matches.push(item);
          }
        }
      } else if (item.menu_items && item.menu_items.length) {
        matches.push(item);
      }
    }
  }
  return matches;
}

export function filterBy(item, _searchTerm) {
  return item.name.toLowerCase().includes(_searchTerm.toLowerCase());
}
export function filterMenuItem(item, _searchTerm, _type, _orderType) {
  if (_type == "menu")
    return item.menu_items.filter(
      (x) =>
        (x.name.toLowerCase().includes(_searchTerm.toLowerCase()) ||
          (x.description &&
            x.description.toLowerCase().includes(_searchTerm.toLowerCase()))) &&
        checkIfItemAvailbleByOrderType(_orderType, x)
    );
  else if (_type == "fav")
    return item.menu_items.filter(
      (x) =>
        x.is_favourite &&
        (x.name.toLowerCase().includes(_searchTerm.toLowerCase()) ||
          (x.description &&
            x.description.toLowerCase().includes(_searchTerm.toLowerCase()))) &&
        checkIfItemAvailbleByOrderType(_orderType, x)
    );
}
export function filterMenuItemByType(item, _orderType) {
  return item.menu_items.filter((x) =>
    checkIfItemAvailbleByOrderType(_orderType, x)
  );
}
export function $_findSpecial(items, _searchTerm, _orderType) {
  var special = "special";
  // if the searchTerm include part of special : all the special category will be returne
  if (!_searchTerm || special.includes(_searchTerm.toLowerCase())) {
    return items.filter((item) =>
      checkIfItemAvailbleByOrderType(_orderType, item.locationMenuItem)
    );
  }

  // else , we will search on the category items
  return items.filter(
    (item) =>
      (item.locationMenuItem.name.toLowerCase().includes(_searchTerm) ||
        (item.locationMenuItem.description &&
          item.locationMenuItem.description
            .toLowerCase()
            .includes(_searchTerm))) &&
      checkIfItemAvailbleByOrderType(_orderType, item.locationMenuItem)
  );
}

export function getLastOrderStatus(status) {
  let obj = {
    text: i18n.t("text.rejected"),
    color: "#FF0000",
    last_update: status.updated_at
  };
  switch (status.order_status) {
    case ORDER_STATUS.PENDING:
      return {
        ...obj,
        ...{
          text: i18n.t("text.pending"),
          color: "#0000FF"
        }
      }

    case ORDER_STATUS.RECEIVED:
      return {
        ...obj,
        ...{
          text: i18n.t("text.received"),
          color: "#FF6600"
        }
      }
    case ORDER_STATUS.ACCEPTED:
      return {
        ...obj,
        ...{
          text: i18n.t("text.accepted"),
          color: "#00FF33"
        }
      }
    case ORDER_STATUS.DELIVERY:
      return {
        ...obj,
        ...{
          text: i18n.t("text.delivery"),
          color: "#006600"
        }
      }
    case ORDER_STATUS.COMPLETED:
      return {
        ...obj,
        ...{
          text: i18n.t("text.completed"),
          color: "#00FF32"
        }
      }
    case ORDER_STATUS.REFUNDED:
      return {
        ...obj,
        ...{
          text: i18n.t("text.refunded"),
          color: "#FF0000"
        }
      }
  }
  return obj;
}

export function getPaymentTypeIcon(type) {
  let icon = "";
  switch (type) {
    case PAYMENT_TYPE.Cash:
      icon = "k-icon-cash";
      break;
    case PAYMENT_TYPE.Card:
      icon = "k-icon-creditcard";
      break;
    case PAYMENT_TYPE.ApplePay:
      icon = "k-icon-applepay";
      break;
    case PAYMENT_TYPE.GooglePay:
      icon = "k-icon-androidpay";
      break;
  }
  return icon;
}

export function getViewOrderTitle(id, order_type) {

  return i18n.t('text.get_view_order_title', {
    order_id: id, type_icon:
      Object.values(ORDER_TYPE).find(x => x.id == order_type)?.icon
  })
}

export function getOpeningTimesReadable(isOpen, openingHoursReadable, orderType) {
  let obj = {};
  let objReadable = {};
  obj.open = isOpen;
  obj.status = isOpen ? i18n.t('text.open') : i18n.t('text.closed');
  obj.openingRedable = [];

  switch (orderType) {
    case ORDER_TYPE.Collection.id:
      objReadable = openingHoursReadable.pickup;
      break;
    case ORDER_TYPE.Delivery.id:
      objReadable = openingHoursReadable.delivery;
      break;
    case ORDER_TYPE.Table.id:
      objReadable = openingHoursReadable.tableordering;
      break;
    default:
      objReadable = openingHoursReadable.opening;
      break;
  }
  if (objReadable) {
    Object.keys(objReadable).forEach(function (key) {
      let today = Vue.prototype.$moment().format("dddd") == key;
      if (today) obj.todayTime = objReadable[key];
      obj.openingRedable.push({
        name: key,
        time: objReadable[key],
        isToday: today,
      });
    });
  }
  return obj;
}

export function generateMenuItemRating(orderItems) {
  return orderItems
    .filter((item) => item.rating)
    .map((item) => {
      if (item.rating) {
        return {
          id: item.id,
          rating: item.rating,
        };
      }
    });
}

export function getKeyByValue(object, value, complexObject = false) {
  const keys = Object.keys(object);
  return complexObject ? keys.find(key => object[key].id === value) : keys.find(key => object[key] === value)
}

export function orderHasDeletedMenuItems(order) {
  return (
    order.orderItems.find(function (orderItem) {
      return orderItem.menuItem == null;
    }) != null
  );
}

export function checkDeliveryAvailibality(
  can_make_order,
  selectedLocation,
  total_price,
  fromAddress = false
) {
  if (!can_make_order) return null;

  if (!selectedLocation.availabe_delivery_postcode) {
    return {
      status: false,
      title: i18n.t("generic_error.delivery_search_error"),
      type: "warning",
    };
  }
  //--- return this message if the check is based on address selection
  //--- TODO : Calculate the delivery_fee based on the card order total and available Areas conditions
  if (fromAddress) {
    let deliveryFee = getDeliveryFee(
      selectedLocation.delivery_condition,
      total_price
    );
    return {
      status: true,
      title: `${i18n.t("text.delivery_fee")} : ${Vue.options.filters.currency(deliveryFee)}`,
      value: deliveryFee,
      type: "success",
    };
  }
  return null; // return null value
}

export function checkMaxQuantitySelectedByOption(option, value) {

  const maxQuantityOptions = option.max_quantity ? option.max_quantity : 999;
  const maxQuantityValues = option.multi_max ? option.multi_max : value.max_quantity ? value.max_quantity : 999;

  const selectedItems = option.type == OPTION_TYPE.checkbox ? option.selected : [option.selected]

  const selectedValueQuantity = selectedItems.filter(s => s == value.id).length;
  const totalSelectedValuesQuantity = selectedItems.length

  return selectedValueQuantity >= maxQuantityValues || totalSelectedValuesQuantity >= maxQuantityOptions;

}

export function menuItemOptionFormatter(options, showPrice = true, prefix = "+", className = "ml-2") {

  let result = ""
  for (const option of options) {
    if (!option.selected_items.length) continue;

    for (const selectedItem of option.selected_items) {
      result += `<div class="options-item-grid">
      <div class="option-name ${className}">${prefix} ${selectedItem.name} (x${selectedItem.quantity})
      </div>`
      if (showPrice) {
        result += `<div class="option-price">
      ${Vue.options.filters.currency(selectedItem.price * selectedItem.quantity)}</div>`
      }
      result += `</div>`

      const valueFound = option.values.find(v => v.id == selectedItem.id);

      if (valueFound) {
        result += menuItemOptionFormatter(valueFound.options, showPrice, "++", "ml-4")
      }
    }

  }
  return result
}

export function orderItemsFormatter(orderItems, classItem = "", className = "", showPrice = true) {

  let result = "";
  orderItems.forEach(orderItem => {

    result += `<div class="item ${classItem}"><div class="quantity">${orderItem.quantity}</div><div class="name ${className}">
    ${orderItem.name}`

    if (orderItem?.sections?.length) {
      result += orderItemsFormatter(orderItem.sections, "ml-1", 'font-weight-normal', false)
    }

    if (orderItem?.options?.length) {
      result += formattedOrderMenuItemOptions(orderItem.options)
    }


    result += `</div>`
    if (showPrice) {
      result += `<div class="price">${orderItem.sub_total}</div>`
    }

    result += `</div>`

  })

  return result;
}

const formattedOrderMenuItemOptions = (options, className = "", plus = "+") => {
  let result = "";
  options.forEach(option => {
    option.values.forEach(value => {
      result += `<p class="mb-0 font-weight-normal ${className}"> ${plus} ${value.name} X(${value.quantity})</p>`
      if (value?.options?.length) {
        result += formattedOrderMenuItemOptions(value.options, 'ml-2', '++')
      }
    })
  })

  return result;
}

export function completedOrderItemCardFormatter(ordreItem, myTheme, orderType, addFav = true) {
  let result = "";
  if (addFav) {
    result += `<div class="box favorite">
    <i
      class="new-ui-icons ${ordreItem.is_favourite ? 'k-icon-tab-favourites fav' : 'k-icon-heart-line'}"
    ></i></div>`
  }

  result += `<div class="box details"><p class="title" style="color:${myTheme.primaryTextColor}">${ordreItem.name}</p>`;

  if (ordreItem?.sections?.length) {
    result += formatSelectedItems(ordreItem.sections, 'ml-2')
  }

  if (ordreItem.options?.length) {
    result += menuItemOptionFormatter(ordreItem.options, false)
  }

  result += '</div>'
  result += `<div class="box price text-center my-auto">
            ${Vue.options.filters.currency(getMenuItemTotal(ordreItem, orderType))}
            </div><div class="box counter text-center my-auto">
            <span>${ordreItem.quantity}x</span>
            </div>`

  return result;
}

export function getAllSelectedOrderItems(orderItems) {

  let result = {
    menuItems: [],
    options: [],
    values: []
  }

  orderItems.forEach(orderItem => {
    result.menuItems.push(orderItem.id)

    if (orderItem?.options?.length) {
      result = getAllSelectedOrderItemOptions(orderItem.options, result)
    }

    if (orderItem?.sections?.length) {

      orderItem?.sections.forEach(section => {
        if (section.selected_items?.length) {
          result.menuItems = [...result.menuItems, ...[section.id]]
          result.menuItems = [...result.menuItems, ...getAllSelectedOrderItems(section?.subProducts?.filter(p => section.selected_items.map(b => b.id).includes(p.id))).menuItems]
        }
      })
    }

  })

  return result;
}

const getAllSelectedOrderItemOptions = (options, result) => {

  options.forEach(option => {
    if (!_.isEmpty(option.selected)) {
      result.options.push(option.id)
      if (option.type == OPTION_TYPE.checkbox) {
        result.values = [...result.values, ...option.selected]
      } else {
        result.values.push(option.selected)
      }
    }
    option.values.forEach(value => {

      if (value?.options?.length) {
        result = getAllSelectedOrderItemOptions(value.options, result)
      }
    })
  })

  return result;
}

export function checkIfTheItemHasSameOptions(newOrderItem, oldOrderItem) {

  if (!newOrderItem.hasOptions && !newOrderItem.is_meal_deal && newOrderItem.comment == oldOrderItem.comment) {
    return true;
  }

  if (newOrderItem.comment != oldOrderItem.comment) {
    return false;
  }

  // we have to check the selected options for both modifiers and bundles (meal deal)
  if (newOrderItem.hasOptions && !checkSelectedSameOptions(newOrderItem.options, oldOrderItem.options)) {
    return false
  }

  if (newOrderItem.is_meal_deal && !checkSelectedSameOptions(newOrderItem.sections, oldOrderItem.sections)) {
    return false
  }

  return true

}
export function checkSelectedSameOptions(newOptions, oldOptions) {

  for (const newOption of newOptions) {
    const oldOption = oldOptions.find(op => op.id === newOption.id)

    if (newOption.selected_items.length != oldOption.selected_items.length) {
      return false;
    }

    const check = newOption.selected_items.every(value => oldOption.selected_items.find(oldValue => oldValue.id == value.id && oldValue.quantity == value.quantity))

    if (!check) return false;

    if (newOption.values?.length) {
      for (const newValue of newOption.values) {

        if (!newValue.options?.length) continue;
        const oldValue = oldOption.values.find(v => v.id == newValue.id);

        if (!checkSelectedSameOptions(newValue.options, oldValue.options)) return false;
      }
    }

  }
  return true;
}
